import { getFromStorage } from '../../config/auth.config';
import { BaseService } from '../base-service'

export interface ICreateEncounterRequest{
    encounter: {
        authoringSystem: string;
        authoringSystemForeignKey: string
    }
}
export interface ILookupIdentifier{
    id: string;
    authoringSystem: string;
    authoringSystemForeignKey: string
}
export interface ICreateEncounterResponse{
    encounter: ILookupIdentifier,
    patient: ILookupIdentifier,
    encounterPlace: ILookupIdentifier
}
class EncounterApiV1 {

    async createEncounter(request:ICreateEncounterRequest):Promise<ICreateEncounterResponse>{
        let path="/api/v1/encounter";
        const sharedProviderPath = getFromStorage("providerId");
        if (sharedProviderPath) {
          path = path + "?" + sharedProviderPath;
        }
        let response = await BaseService.AsyncPost(path, request);
        return response as ICreateEncounterResponse;
    }
}


const encounterService = new EncounterApiV1();

export { encounterService };